<template>
<div class="expandBtn">
  <el-button type="warning" size="mini" :plain="scope.row.show" @click="changeStatus(scope.row)">
    {{getDesc(scope.row)}}
    <i class=" el-icon--right" :class="scope.row.show ? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
  </el-button>
</div>

</template>
<script>
    export default {
       name: "expand-table",
        props: ['tableData', 'scope'],
        data () {
            return {}
        },
        computed: {},
        watch: {},
        mounted () {
        },
        methods: {
          getDesc (row) {
            return row.show ? '收起' : '展开'
          },
          changeStatus (row) {
            row.show = !row.show
            this.$parent.store.toggleRowExpansion(row)
          }
        }
    }
</script>
<style lang="scss" scoped>
  .expandBtn {
    color: #fff;
    .el-button--warning {
      padding: 7px 9px;
    }
     .el-button--warning.is-plain:active, .el-button--warning.is-plain:focus, .el-button--warning.is-plain:hover{
      color: #FCC262;
      background: #fff9ef;
      border-color: #fee7c0
    }
  }
</style>
